import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRecordingsBackupStatus } from '../../services';
import { hasFeature } from '../../services/permissions';
import { cloneBanner, stateView } from '../Config/System/RecordingsBackup/recordingsBackupScreen';
import '../Config/System/RecordingsBackup/RecordingsBackup.css';

const VISIBLE_POLL_MS = 5 * 60 * 1000;

const bannerText = (status) => {
  if (!status || !status.alerts) return '';
  if (status.alerts.notRegistered) {
    if (status.state === 'CLONE_DETECTED') return cloneBanner(status.hostName);
    return stateView(status.state).banner || 'Backup não configurado';
  }
  if (status.alerts.stale) return 'O backup de gravações não envia há mais de 26 horas.';
  if (status.alerts.diskHigh) return 'O disco de gravações passou de 80%.';
  return '';
};

const RecordingsBackupBanner = ({ poll = process.env.NODE_ENV !== 'test' }) => {
  const [text, setText] = useState('');
  const allowed = hasFeature('system.backup_gravacoes', 'view');

  useEffect(() => {
    if (!poll || !allowed) return undefined;
    let timer = null;
    let stopped = false;
    const load = async () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      const result = await getRecordingsBackupStatus();
      if (stopped || !result || !result.success) return;
      setText(bannerText(result.data));
    };
    load();
    timer = setInterval(load, VISIBLE_POLL_MS);
    document.addEventListener('visibilitychange', load);
    window.addEventListener('focus', load);
    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', load);
      window.removeEventListener('focus', load);
    };
  }, [poll, allowed]);

  if (!allowed || !text) return null;
  return (
    <div className="notification is-danger is-light recordings-backup-banner" role="status">
      <Link to="/config/sistema/backup-gravacoes">{text}</Link>
    </div>
  );
};

export default RecordingsBackupBanner;
